export const CONTACT_EMAIL = 'hello@teamplay.gg';
export const DISCORD_URL = 'https://discord.gg/gt56cQ4nWb';

export type CollabTrack = {
  id: string;
  eyebrow: string;
  title: string;
  summary: string;
  points: string[];
  cta: string;
  ctaAction: string;
};

export const COLLAB_TRACKS: CollabTrack[] = [
  {
    id: 'partnerships',
    eyebrow: 'Partnerships',
    title: 'Communities & platforms',
    summary:
      'Bring Teamplay to your community – Discords, guilds, tournaments, and gaming platforms that want an easy way for members to find people to play with.',
    points: [
      'Co-branded LFG hubs and sessions',
      'Cross-promotion and shared events',
      'Integrations that fit your community',
    ],
    cta: 'Talk partnerships',
    ctaAction: 'partner_partnerships',
  },
  {
    id: 'sponsorships',
    eyebrow: 'Sponsorships',
    title: 'Brands & creators',
    summary:
      'Reach an engaged audience of players who show up to team up. Sponsor sessions, events, and content that lands natively with gamers.',
    points: [
      'Sponsored sessions and in-app moments',
      'Creator and tournament activations',
      'Campaigns built for a gaming audience',
    ],
    cta: 'Discuss a sponsorship',
    ctaAction: 'partner_sponsorships',
  },
  {
    id: 'investment',
    eyebrow: 'Investment',
    title: 'Investors & partners',
    summary:
      'We are building the social layer for playing together. If you back early-stage gaming and social products, we would love to talk.',
    points: [
      'Growing LFG platform with real traction',
      'Small, fast team shipping weekly',
      'Clear vision for the social play space',
    ],
    cta: 'Request our deck',
    ctaAction: 'partner_investment',
  },
];

export type ValuePoint = { title: string; description: string };

export const VALUE_POINTS: ValuePoint[] = [
  {
    title: 'Engaged players',
    description: 'People come to Teamplay to team up and play – an audience that shows up, not just scrolls.',
  },
  {
    title: 'Native to gaming',
    description: 'Sessions, voice, and LFG. Whatever we build together fits how gamers actually play.',
  },
  {
    title: 'Fast and flexible',
    description: 'Small team, no red tape. We move from idea to live quickly and shape deals around you.',
  },
  {
    title: 'Growing with you',
    description: 'Early partners grow with the platform as it scales across communities and games.',
  },
];

export type ProcessStep = { step: number; title: string; description: string };

export const PROCESS_STEPS: ProcessStep[] = [
  {
    step: 1,
    title: 'Reach out',
    description: 'Send us a note about what you have in mind – partnership, sponsorship, or investment.',
  },
  {
    step: 2,
    title: 'Quick chat',
    description: 'A short call to align on goals and see where it makes sense to work together.',
  },
  {
    step: 3,
    title: 'Make it happen',
    description: 'We shape the collaboration, agree on the details, and get it live.',
  },
];
